export const normalizeLanguageValue = value => {
  const normalized = String(value || '')
    .trim()
    .toLowerCase();
  return normalized || null;
};

export const hasCompanyLanguageChanged = (currentLanguage, initialLanguage) =>
  normalizeLanguageValue(currentLanguage) !== normalizeLanguageValue(initialLanguage);

export const hasStationLanguageChanged = (station, initialStations = []) => {
  const initialStation = initialStations.find(item => item.id === station.id);
  return (
    Boolean(initialStation) &&
    normalizeLanguageValue(station.language) !== normalizeLanguageValue(initialStation.language)
  );
};

export const filterChangedStationIds = (selectedStationIds, currentStations, initialStations) =>
  selectedStationIds.filter(stationId => {
    const station = currentStations.find(item => item.id === stationId);
    return station && hasStationLanguageChanged(station, initialStations);
  });
